import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useLocation, useNavigate } from "react-router";
import { editfaqs, editsubcategorylist } from "../../service/Mainservice";
import Loader from "../../Loader/Loader";

const validate = (values, isInitialLoad) => {
  const errors = {};
  if (isInitialLoad) return errors;

  if (!values.que) {
    errors.que = "Required";
  }
  if (!values.ans) {
    errors.ans = "Required";
  }
  return errors;
};

const Editfaqs = () => {
  const [load, setload] = useState(false);
  const [success, setsuccess] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const items = location.state.item;
  console.log(location);

  useEffect(() => {
    formik.setValues(
      {
        que: items.question,
        ans: items.answer,
      },
      false
    );
    formik.validateForm();
  }, [items]);

  const formik = useFormik({
    initialValues: {
      que: "",
      ans: "",
    },
    validate: (values) => validate(values, isInitialLoad),
    onSubmit: (values) => {
      handleAdd(values);
    },
  });

  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await editfaqs(items.id, values.que, values.ans);
      setsuccess(response.data.message);
      setOpen2(true);
      setload(false);
      setTimeout(() => {
        navigate("/FAQS_List");
      }, 1000);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Edit FAQS</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Question</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="que"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.que}
              className="Auth_input"
            />
            {formik.errors.que ? (
              <p className="invalid">{formik.errors.que} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Answer</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="ans"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.ans}
              className="Auth_input"
            />
            {formik.errors.ans ? (
              <p className="invalid">{formik.errors.ans} </p>
            ) : null}
          </div>
          <div />

          <button className="term_button" type="Submit">
            {load ? "Updating..." : "Save"}
          </button>
        </form>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={2000}
        onClose={() => setOpen2(false)}
      >
        <Alert severity="success" variant="filled" sx={{ width: "70vw" }}>
          {success}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Editfaqs;
